
<div class="time-input-container" [class.format-24]="!showMeridian">

     <span class="required_field" *ngIf="showTitle">Time</span>
    <div class="time-input-box" [class.format-24]="!showMeridian">

        <!-- Hour -->
        <input
            #hourInput
            (click)="onHourClick()"
            (focus)="onHourFocus($event)"
            class="time-part"
            maxlength="2"
            [value]="hour"
            [readonly]="!allowTyping"
            (input)="allowTyping ? onHourInput($event) : null"
            (keydown)="allowTyping ? onHourKeydown($event) : $event.preventDefault()"
            (keypress)="allowTyping ? null : $event.preventDefault()"
            (paste)="allowTyping ? null : $event.preventDefault()"
            (blur)="onBlur()"
            [class.active-input]="showDropdown"
        />

        <span class="separator">:</span>

        <!-- Minute -->
        <input
            #minuteInput
            (click)="onMinuteClick()"
            (focus)="onMinuteFocus($event)"
            class="time-part"
            maxlength="2"
            [value]="minute"
            [readonly]="!allowTyping"
            (input)="allowTyping ? onMinuteInput($event) : null"
            (keydown)="allowTyping ? onMinuteKeydown($event) : $event.preventDefault()"
            (keypress)="allowTyping ? null : $event.preventDefault()"
            (paste)="allowTyping ? null : $event.preventDefault()"
            (blur)="onBlur()"
            [class.active-input]="showDropdown"
        />

        <div class="meridian-part custom-meridian" (click)="toggleMeridianDropdown()"  *ngIf="showMeridian">
            {{ meridian }}
        </div>
        <i class="fa-solid fa-chevron-down chevron-icon" (click)="toggleMeridianDropdown()" *ngIf="showMeridian"></i>
        <div class="dropdown dropdown-meridian" *ngIf="showMeridianDropdown">
            <div
                class="dropdown-item"
                *ngFor="let m of meridianList"
                (click)="selectMeridian(m)">
                {{ m }}
            </div>
        </div>

    </div>

    <div class="dropdown" *ngIf="showDropdown">
        <div class="dropdown-values">
            <div
                class="dropdown-item"
                *ngFor="let t of timeList"
                [class.selected]="t === (hour + ':' + minute)"
                (click)="chooseTime(t)">
                {{ t }}
            </div>
        </div>
    </div>


</div>
